module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-client"
  }, [_c('el-form', {
    ref: "clientData",
    staticClass: "edit-client-form",
    attrs: {
      "model": _vm.clientData,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clientData.name),
      callback: function($$v) {
        _vm.$set(_vm.clientData, "name", $$v)
      },
      expression: "clientData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clientData.address),
      callback: function($$v) {
        _vm.$set(_vm.clientData, "address", $$v)
      },
      expression: "clientData.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Latitude",
      "prop": "lat"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clientData.latitude),
      callback: function($$v) {
        _vm.$set(_vm.clientData, "latitude", $$v)
      },
      expression: "clientData.latitude"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Longitude",
      "prop": "long"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clientData.longitude),
      callback: function($$v) {
        _vm.$set(_vm.clientData, "longitude", $$v)
      },
      expression: "clientData.longitude"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zoom",
      "prop": "zoom"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clientData.zoom),
      callback: function($$v) {
        _vm.$set(_vm.clientData, "zoom", $$v)
      },
      expression: "clientData.zoom"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sunset Offset (minutes before)",
      "prop": "sunset_offset"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.clientData.sunset_offset),
      callback: function($$v) {
        _vm.$set(_vm.clientData, "sunset_offset", $$v)
      },
      expression: "clientData.sunset_offset"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.submit('clientData')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65388c84","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Clients/EditClient.vue
// module id = 984
// module chunks = 11